import { OfferCard } from '@libs/creditkit';
import { OfferProps } from '@hub/types';
import { useUserContext } from '@common/contexts/UserContext';

export const MainOfferCard = ({
  offer,
  index,
  location,
  smallCard = false,
}: OfferProps) => {
  const { user } = useUserContext();

  return (
    <OfferCard
      offer={offer}
      index={index}
      location={location}
      user={user}
      smallCard={smallCard}
    />
  );
};
